// imports section
import React from "react";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import AppBar from "@mui/material/AppBar";
import { Autocomplete } from "@mui/material";
import AddToolbar from "../../components/common/AddToolbar";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import { useState, useEffect } from "react";
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import {
  EMPLOYEE_API_01,
  EMPLOYEE_API_05,
  EMPLOYEE_API_06,
} from "../../api/ApiModel";
import { useSelector } from "react-redux";
import {
  CON_STATUS_ACTIVE,
  CON_STATUS_DELETED,
} from "../../utils/sys/Constants";
import Slide from "@mui/material/Slide";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
// import { useNavigate, useLocation } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { isValidDateValue } from "@testing-library/user-event/dist/utils";

const querys = ["yes", "No"];

const MapUser = () => {
  // Hooks
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [userGroups, setUserGroups] = useState([]);
  const [userNames, setUserNames] = useState([]);
  const [selectedName, setSelectedName] = useState("");
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [checkedItems, setCheckedItems] = useState([]);
  const [accessRights, setAccessRights] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const isEdit = location.state?.actionText === "Edit";
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    USERGROUP: "",
    USERNAME: "",
    STARTDATE: "",
  });
  const [errors, setErrors] = useState({});
  const [snackbarMessage, setSnackbarMessage] = useState("");

  useEffect(() => {
    if (selectedItem) {
      // console.log('xxxxxxxxx');
      setSelectedItemDetails({
        USERNAME: selectedItem.USERNAME,
        USERGROUP: String(selectedItem.GROUPCODE),
        STARTDATE: String(selectedItem.STARTDATE),
      });
    }
  }, [selectedItem]);

  // Handlers

  const gotToView = () => {
    navigate("/vMapUser");
  };

  const handleGroupChange = (event) => {
    // setSelectedGroup(event.target.value);
    const { name, value } = event.target;
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
    setSelectedItemDetails({
      ...selectedItemDetails,
      [name]: value,
    });
  };
  const handleUserChange = (event) => {
    // setSelectedName(event.target.value);
    const { name, value } = event.target;

    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
    setSelectedItemDetails({
      ...selectedItemDetails,
      [name]: value,
    });
  };

  const handleDateChange = (date, name) => {
    // Convert Dayjs object to the desired format or leave as Dayjs object if preferred
    const formattedDate = date ? date.format("YYYY-MM-DD") : "";
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
    setSelectedItemDetails((prevState) => ({
      ...prevState,
      [name]: formattedDate,
    }));
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, BUSINESSTYPECODE, RESTCODE, USERNAME, GROUPCODE } =
    SYS_USER.USER_PARAM || {};
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch user groups from API
  const fetchUserGroups = async () => {
    setLoading(true);
    try {
      const params = {
        COMPCODE,
        LOCCODE,
        BUSINESSTYPECODE,
        STS: CON_STATUS_ACTIVE,
      };
      const response = await externalgetApi(EMPLOYEE_API_01, "GET", params);
      console.log("Request data userGroups:", JSON.stringify(response));
      setUserGroups(response); // Assuming response is an array of user groups
    } catch (error) {
      setError("Failed to fetch user groups.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch user names from API
  const fetchUserNames = async () => {
    setLoading(true);
    try {
      const params = {
        COMPCODE,
        LOCCODE,

        STS: CON_STATUS_ACTIVE,
      };
      const response = await externalgetApi(EMPLOYEE_API_06, "GET", params);
      setUserNames(response); // Assuming response is an array of user names
    } catch (error) {
      setError("Failed to fetch user names.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserGroups();
  }, []);

  useEffect(() => {
    fetchUserNames();
  }, []);

  const handleConfirmClick = async () => {
    const { USERNAME, USERGROUP, GROUPCODE, STARTDATE } = selectedItemDetails;

    const requiredFields = [
      { name: "USERNAME", value: USERNAME, label: "Username" },
      { name: "USERGROUP", value: USERGROUP, label: "User Group" },
      { name: "STARTDATE", value: STARTDATE, label: "Start Date" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`; // Set error message for each missing field
      });

      setErrors(newError); // Set the error state
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Required fields: ${missingFieldLabels}.`;

      setSnackbarMessage(errorMessage); // Show snackbar with missing fields
      setOpenErrorSnackbar(true);
      return; // Stop submission if there are validation errors
    }

    const staticValues = {
      COMPCODE,
      LOCCODE,
      RESTCODE,
      ACTSTS: CON_STATUS_ACTIVE,

      locdate: String(new Date().toISOString().split("T")[0]),
      delsts: CON_STATUS_DELETED,
      Enuser: USERNAME,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(EMPLOYEE_API_05, payload);
      console.log("Success:", responseData);
      setOpenSnackbar(true);
      setSelectedItemDetails({
        STARTDATE: "",
      });
    } catch (error) {
      console.error("Error:", error);
    }
    setTimeout(() => {
      navigate("/vMapUser");
    }, 2000);
  };

  const clearUserAccount = () => {
    setSelectedItemDetails({
      USERNAME: "",

      STARTDATE: "",
      GROUPNAME: "",
    });
    setErrors({}); // Clear any validation errors
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };

  return (
    <div>
      <Navbar />

      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Employee</Link>
                <Link underline="none">Mapuser</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar label={{ name: "Map User" }} />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <Autocomplete
              id="username-autocomplete"
              options={userNames.map((user) => user.USERNAME)} // Array of options
              value={selectedItemDetails.USERNAME} // Controlled value
              onChange={(event, newValue) =>
                handleUserChange({
                  target: { name: "USERNAME", value: newValue },
                })
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="User Name"
                  name="USERNAME"
                  size="small"
                  error={Boolean(errors.USERNAME)}
                  helperText={errors.USERNAME}
                />
              )}
              ListboxProps={{
                style: {
                  maxHeight: 150,
                  backgroundColor: theme.palette.background.paper,
                },
              }}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}></Grid>

          <Grid item lg={6} md={6} xs={12} sm={12}>
            <FormControl size="small" fullWidth>
              <Autocomplete
                options={userGroups || []}
                getOptionLabel={(option) => option.GROUPNAME || ""}
                value={
                  userGroups.find(
                    (group) =>
                      String(group.GROUPCODE) ===
                      String(selectedItemDetails.USERGROUP)
                  ) || null
                }
                onChange={(event, newValue) => {
                  // Clear the error for the current field if applicable
                  if (errors.USERGROUP) {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      USERGROUP: "",
                    }));
                  }

                  // Update the selected item details
                  setSelectedItemDetails((prevState) => ({
                    ...prevState,
                    USERGROUP: newValue ? String(newValue.GROUPCODE) : "",
                    GROUPNAME: newValue ? newValue.GROUPNAME : "", // Update GROUPNAME as well
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    labelId="group-select-label"
                    id="group-select"
                    label="User Group"
                    name="USERGROUP"
                    size="small"
                    error={Boolean(errors.USERGROUP)}
                    helperText={errors.USERGROUP}
                  />
                )}
                ListboxProps={{
                  style: {
                    maxHeight: 150,
                    backgroundColor: theme.palette.background.paper,
                  },
                }}
              />
            </FormControl>
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}></Grid>

          <Grid lg={6} md={6} xs={12} sm={12} pt={2} pl={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Start Date"
                selected={new Date()}
                value={
                  selectedItemDetails.STARTDATE
                    ? dayjs(selectedItemDetails.STARTDATE)
                    : null
                }
                onChange={(newValue) => handleDateChange(newValue, "STARTDATE")}
                slotProps={{
                  textField: {
                    error: Boolean(errors.STARTDATE), // Pass error here
                    helperText: errors.STARTDATE,
                    sx: {
                      width: "100%",
                      "& .MuiInputLabel-root": {
                        mt: "-0.5rem",
                        fontSize: "15px",
                      },
                      "& .MuiInputBase-root": {
                        height: "40px",
                      },
                      "& .MuiInputAdornment-root .MuiIconButton-root": {
                        color: theme.palette.primary.main, // Change icon color here
                      },
                    },
                  },
                  popper: {
                    sx: {
                      "& .MuiPaper-root": {
                        backgroundColor: theme.palette.background.default, // Background color of the popper
                        boxShadow: "none", // Remove box shadow if needed
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>

        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={clearUserAccount}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
          >
            Confirm
          </Button>
        </Stack>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          // Slide in from the right
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {" Maped User successfully!"}
          </Alert>
        </Snackbar>
        <Snackbar
          open={openErrorSnackbar}
          autoHideDuration={3000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default MapUser;
